import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import * as mortgageModels from '@modules/mortgage/models';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import {
  RealPropertyMortgageCalculatorService
} from '@modules/real-property-details/components/real-property-mortgage-calculator/real-property-mortgage-calculator.service';
import { debounceTime, map } from 'rxjs/operators';
import * as mortgageServices from '@modules/mortgage/services';
import { SettingsService } from '@app/settings.service';
import { NgxMaskModule } from 'ngx-mask';
import { DropdownComponent } from '@app/shared/dropdown/dropdown.component';
import { SliderModule } from 'primeng/slider';

@Component({
  selector: 'app-calculator',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, NgxMaskModule, DropdownComponent, SliderModule],
  templateUrl: './calculator.component.html',
  styleUrls: ['./calculator.component.scss'],
})
export class CalculatorComponent implements OnInit {

  @Input() objectPrice: number;

  currentLanguageAsKey = this._settingsService.getCurrentLanguageAsKey();

  creditProgram: mortgageModels.CreditProgramList;
  selectedCreditProgram: any = {
    minCreditPeriod: null,
    maxCreditPeriod: null,
    percent: null,
  };
  monthlyPay: number = 0;

  calculatorForm: FormGroup;

  constructor(
    private realPropertyMortgageService: RealPropertyMortgageCalculatorService,
    private mortgageService: mortgageServices.MortgageService,
    private _settingsService: SettingsService,
  ) {}

  ngOnInit() {
    this.calculatorForm = new FormGroup<any>({
      contribution: new FormControl(),
      term: new FormControl(),
      income: new FormControl(0),
      program: new FormControl(1),
    });
    this.mortgageService.getCreditProgram().pipe(
      map((res) => res.map((item) => ({ ...item, minCreditPeriod: item.minCreditPeriod * 10, name: item[this.currentLanguageAsKey]})))
    )
      .subscribe((res) => {
        this.creditProgram = res;
        this.selectedCreditProgram = res[0];
        setTimeout(() => {
          this.calculatorForm.patchValue({
            contribution: this.selectedCreditProgram.minDownPayment,
            term: this.selectedCreditProgram.minCreditPeriod,
          });
        }, 1000);
      });

    this.calculatorForm.valueChanges.pipe(debounceTime(300))
      .subscribe(() => {
        this.getMonthlyPay();
      });
  }

  onInputChange(value: any, control: string): void {
    this.calculatorForm.get(control)?.setValue(value.target.value.replaceAll(' ', ''), { emitEvent: true });
  }

  getMonthlyPay(): void {
    if (this.calculatorForm.get('income').value && this.calculatorForm.get('contribution').value) {
      const payment = {
        creditTerm: +this.calculatorForm.get('term').value,
        initialFee: this.calculatorForm.get('contribution').value,
        totalIncome: this.calculatorForm.get('income').value,
        interestRate: this.selectedCreditProgram.percent,
        objectPrice: this.objectPrice,
      };
      this.realPropertyMortgageService.getMortgageMonthlyPay(payment).subscribe((res) => {
        this.monthlyPay = res;
      });
    }
  }

  programSelect(value: any) {
    this.selectedCreditProgram = value;
    this.calculatorForm.patchValue({
      contribution: value.minDownPayment,
      term: value.minCreditPeriod,
    });
  }
}
